import {
  useDialogDisclosure
} from "../__chunks/5I6BQS7D.js";
import "../__chunks/LDJKN2ZV.js";
import "../__chunks/O6CV6VRM.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import {
  useEvent
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/combobox/combobox-disclosure.tsx
import { jsx } from "react/jsx-runtime";
var children = /* @__PURE__ */ jsx(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5pt",
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    pointerEvents: "none",
    children: /* @__PURE__ */ jsx("polyline", { points: "4,6 8,10 12,6" })
  }
);
var useComboboxDisclosure = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const onMouseDownProp = props.onMouseDown;
    const onMouseDown = useEvent((event) => {
      onMouseDownProp == null ? void 0 : onMouseDownProp(event);
      event.preventDefault();
      store.move(null);
    });
    const onClickProp = props.onClick;
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented)
        return;
      const { baseElement } = store.getState();
      store.setDisclosureElement(baseElement);
    });
    const label = store.useState(
      (state) => state.open ? "Hide popup" : "Show popup"
    );
    props = __spreadProps(__spreadValues({
      children,
      tabIndex: -1,
      "aria-label": label
    }, props), {
      onMouseDown,
      onClick
    });
    props = useDialogDisclosure(__spreadValues({ store }, props));
    return props;
  }
);
var ComboboxDisclosure = createComponent(
  (props) => {
    const htmlProps = useComboboxDisclosure(props);
    return createElement("button", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  ComboboxDisclosure.displayName = "ComboboxDisclosure";
}
export {
  ComboboxDisclosure,
  useComboboxDisclosure
};
